import { CongestionReportsResponse } from '../hooks/useCongestionReports';
import { getCongestionReportUrl } from './getCongestionReportUrl';

export type ReportUrl = {
  name: string;
  congestionType: string;
  link: string | undefined;
  target: string | undefined;
};

export const getReportUrls = (
  relatedReports: CongestionReportsResponse[] | undefined,
  reportUrl: string | undefined,
  target: string | undefined
): ReportUrl[] | undefined => {
  if (!relatedReports?.length) return [];

  const reportUrls = relatedReports
    .map(({ name, congestionType }) => {
      if (!name || !congestionType) return [];

      const link = reportUrl ? getCongestionReportUrl(name, congestionType, reportUrl) : undefined;

      return {
        name,
        congestionType,
        link,
        target,
      };
    })
    .filter((item): item is ReportUrl => !!item);

  return reportUrls;
};

